// modules/SiteDownloadButton.js
import React        from 'react';

class SiteDownloadButton extends React.Component {
	render() {
		if (this.props.buttonlink) {
			return (
				<div className="w-100 w-50-md fl-md tc">
					<div className="btn__container m-b-1 m-b-0-lg p-v-1 p-v-0-lg">
						<a className="btn btn__action w-90-lg w-100" href={this.props.buttonlink} target="_blank">
							<i className="icon icon--download"></i><span>{this.props.children}</span>
						</a>
					</div>
				</div>
			)
		} else {
			return null;
		}
	}
}

export default SiteDownloadButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/SiteDownloadButton.js
 **/